import BaseAnnotationLayer from "./BaseAnnotationLayer";

class PreviewBloodLayer extends BaseAnnotationLayer {
    id = 'previewblood';
    label = "Preview Layer";
    
    // We will never change the source of this layer
    componentDidUpdate(prevProps, prevState, snapshot) {
    }
}

export default PreviewBloodLayer;
